<template>
  <RouterView v-slot="{ Component, route }">
    <transition name="slide-down" mode="out-in">
      <component :is="Component" :key="route.fullPath" />
    </transition>
  </RouterView>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
/* 1. 【抗抖动关键】给整个页面容器加最小高度和滚动条预留 */
/* 推荐在 App.vue 或全局样式中设置，防止滚动条切换导致水平抖动 */
html {
  overflow-y: scroll; /* 强制永远保留滚动条宽度，避免切换时页面左右晃动 */
}

/* 2. 过渡动画定义 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 2s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* 使用 will-change 开启硬件加速，减少卡顿 */
  will-change: transform, opacity;
  /* 防止内部元素溢出导致滚动条闪动 */
  overflow: hidden;
}

/* 进入之前：向上偏移 30px 且透明（视觉上在“上面”） */
.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-30px);
}

/* 进入完成：归位，不透明 */
.slide-down-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* 离开过渡：为了不抢风头，让它更快消失并稍微向上移动 */
.slide-down-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* 离开结束：透明并向上移动 20px（视觉上像被“抽走”） */
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

</style>>
